import React, { useEffect, useRef, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Box, Button, Stack } from '@mui/material';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import ActionDetails from '../../../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../../../components/mui/GlobalAnchor/GlobalAnchorList';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CROStudentStatus from './CROStudentStatus';
import { getCroLeadsAll } from '../../../../redux/features/croSlice';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import { CRO_LEAD_TABLE_HEAD } from '../../../../components/datagrid/CRM/CrmLead/CRotablehead';
import CourseEnrollment from './CourseEnroll';
import CopyDataToSheet from '../../../../components/CopyDataToSheet';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';
import CartEditRequest from '../../../cartEdit/CartEditRequest';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import useResponsive from '../../../../Hooks/useResponsive';

const CROleads = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { croLeadsAll, loading } = useSelector((state) => state.cro);
  const isResettingPage = useRef(false);
  const [value, setValue] = useState(dayjs());
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const data = {
    page: pageNum,
    limit: gridSize,
    search: search,
    // date: dayjs(value).format('YYYY-MM'), //currently not taking
    fromDate: fromDate,
    toDate: toDate,
  };
  const dataforExport = {
    page: pageNum,
    limit: 'no',
    search: search,
    // date: dayjs(value).format('YYYY-MM'),
    fromDate: fromDate,
    toDate: toDate,
  };

  useEffect(() => {
    //IT IS DEPENDECY FOR PAGE RESET TO PAGE NUMBER 1
    isResettingPage.current = true;
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [search, value]);

  useEffect(() => {
    if (pageNum && gridSize) {
      if (isResettingPage.current) {
        //WHEN THE SEARCH OR FILTER CHANGE INITIALLY IT USE REF TRUE AND IT WILL ONLY CALL PAGENUM =1 OTHER WISE JUST RETUN EMPTY
        if (pageNum == 1) {
          dispatch(getCroLeadsAll(data));
        }
        isResettingPage.current = false;
        return;
      } else {
        dispatch(getCroLeadsAll(data));
      }
    }
  }, [pageNum, gridSize, value, search,fromDate,toDate]);

  return (
    <>
      <GlobalWrapper title={'CRO Leads'}>
        <Box mb={1} sx={{ display: 'flex',flexDirection:{xs:'column',sm:'row'}, justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <Box>
            <FromAndToDatePicker
              fromLabel="From Date"
              toLabel="To Date"
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
            />
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Year/Month"
                value={value}
                views={['year', 'month']}
                onChange={(newValue) => setValue(newValue)}
                format="YYYY-MM" //
              />
            </LocalizationProvider> */}
          </Box>
          <CopyDataToSheet data={data} api={getCroLeadsAll} loading={loading} />
        </Box>
        <Box sx={{ width: '100%', padding: 0 }}>
          <GlobalDatagrid
            tableHead={CRO_LEAD_TABLE_HEAD}
            rows={croLeadsAll.data}
            meta={croLeadsAll?.meta?.totalRecords || 0}
            loading={loading}
            rowUniqueId="sl_no"
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.name} />
                <GlobalAnchorList
                  label={'Student Status'}
                  component={<CROStudentStatus rowData={rowData} dispatchdata={data} />}
                />
                <GlobalAnchorList
                  component={
                    <CourseEnrollment
                      courseenrollmentId={rowData?.course_enrollment_id}
                      studentStatus={rowData?.student_status}
                      FeePersession={rowData?.sroFeePerSession}
                      dispatchdata={data}
                    />
                  }
                  label={''}
                />
                <GlobalAnchorList
                  component={
                    <Box>
                      <Button
                        sx={{
                          p: '7px',
                          px: '10px',
                          background: 'linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))',
                          color: '#fff',
                          '&:hover': {
                            background: 'linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))',
                          },
                        }}
                        onClick={() =>
                          navigate(
                            `/my-workspace/session-preference?courseenrollmentId=${rowData?.course_enrollment_id}&studentname=${rowData?.name}&course=${rowData?.assigned_course_name}&phone=${rowData?.contactNumber}`,
                          )
                        }
                        disabled={rowData?.isEnrolled === false}
                      >
                        <Icon icon="healthicons:i-schedule-school-date-time" width="20" height="20" />
                        Add Session Preference
                      </Button>
                    </Box>
                  }
                />
                <GlobalAnchorList
                  component={
                    <CartEditRequest
                      courseenrollmentId={rowData?.course_enrollment_id}
                      dispatchdata={data}
                      row={rowData}
                      requestSection={true}
                    />
                  }
                  label={'Cart Edit'}
                />
              </>
            }
          />
        </Box>
      </GlobalWrapper>
    </>
  );
};

export default CROleads;
